import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: '/api/factory/area',
    name: 'factoryLocationPOST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
